import { render, staticRenderFns } from "./arrival-record.vue?vue&type=template&id=b7bbd8ec&scoped=true&"
import script from "./arrival-record.vue?vue&type=script&lang=js&"
export * from "./arrival-record.vue?vue&type=script&lang=js&"
import style0 from "./arrival-record.vue?vue&type=style&index=0&id=b7bbd8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bbd8ec",
  null
  
)

export default component.exports